if (!customElements.get('field-image')) {
  customElements.define(
    'field-image',
    class FieldImage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.input = this.querySelector('input[type="file"]');
        this.removeBtn = this.querySelector('.field__image--remove');

        this.input.addEventListener('change', this.onFileUpload.bind(this));
        this.removeBtn.addEventListener('click', this.onRemoveBtnClick.bind(this));
      }

      onFileUpload(evt) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.classList.add('field__image--has-file');
          this.style.backgroundImage = `url(${reader.result}), linear-gradient(rgba(var(--color-foreground), 0.2), rgba(var(--color-foreground), 0.2))`;
        });
        reader.readAsDataURL(evt.target.files[0]);
      }

      onRemoveBtnClick(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        this.classList.remove('field__image--has-file');
        this.style.backgroundImage = '';
        this.input.value = '';
      }
    }
  )
}
